/**
 * A product property as text. Crawled product data carries arrays and nested objects (a component's
 * technical data, a dimension table per width); `String(value)` showed those as „[object Object]“ on the
 * asset's product tab. Nested keys are joined with „ › “, entries with „; “, empty values are left out.
 */
export const productPropertyValue = (value: unknown): string => {
  if (value === null || value === undefined) return "";
  if (Array.isArray(value)) return value.map(productPropertyValue).filter(Boolean).join("; ");
  if (typeof value === "object") {
    const parts: string[] = [];
    const walk = (node: unknown, path: string[]) => {
      if (node === null || node === undefined || node === "") return;
      if (Array.isArray(node)) {
        const text = node.map(productPropertyValue).filter(Boolean).join(", ");
        if (text) parts.push(path.length ? `${path.join(" › ")}: ${text}` : text);
        return;
      }
      if (typeof node === "object") {
        for (const [key, child] of Object.entries(node as Record<string, unknown>)) walk(child, [...path, key]);
        return;
      }
      parts.push(path.length ? `${path.join(" › ")}: ${String(node)}` : String(node));
    };
    walk(value, []);
    return parts.join("; ");
  }
  return String(value);
};
